import React, { PureComponent } from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment-timezone";
import { numberWithCommas } from "../utils";
import HighchartsCustomEvents from "highcharts-custom-events";
import { getSentimentColor } from "../utils";
import UpIcon from "../../../../../assets/svg/percentage_arrow.svg";
import DownIcon from "../../../../../assets/svg/arrow-down.svg";

HighchartsCustomEvents(Highcharts);
class ConversationOverTimeWithAverageBandChart extends PureComponent {
    chartComponent = React.createRef();
    state = {};

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    getOptions = () => {
        let avgBandValues = this.props.data.avgBandValues;

        let plotYdata = {
            title: "No. of Posts",
            gridLineWidth: this.props.showGridLines ? 2 : 0,
            gridLineDashStyle: "ShortDash",
            gridLineColor: "#ccd6eb",
            lineColor: "#ccd6eb",
            lineWidth: 1,
            max: Math.max(avgBandValues[0], this.props.data.maxValue),
            min: Math.min(avgBandValues[1], this.props.data.minValue),
            plotLines: [
                {
                    color: "#008080", // Color value
                    value: avgBandValues[0], // Value of where the line will appear
                    width: 2, // Width of the line
                    zIndex: 4,
                    label: {
                        align: "right",
                        text: `Average Upper Band : ${numberWithCommas(avgBandValues[0])}`,
                        style: {
                            color: "#008080",
                            fontWeight: "bold",
                        },
                    },
                },
                {
                    color: "#daa520", // Color value
                    value: avgBandValues[1], // Value of where the line will appear
                    width: 2, // Width of the line
                    zIndex: 4,
                    label: {
                        align: "right",
                        text: `Average Lower Band : ${numberWithCommas(avgBandValues[1])}`,
                        style: {
                            color: "#daa520",
                            fontWeight: "bold",
                        },
                    },
                },
            ],
            labels: {
                style: {
                    color: this.props.insights__recommendation ? "white" : "#333333",
                },
            },
        };

        let self = this;

        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let tzo = JSON.parse(localStorage.company).user_timezone * -60;

        let plotComaprisiondata;

        let plotComaprisiondataCondition = this.props.comparisionData && this.props.comparisionData.chartData.length >= this.props.data.chartData.length;

        if (plotComaprisiondataCondition && this.props.data) {
            plotComaprisiondata = JSON.parse(JSON.stringify(this.props.data.chartData));

            this.props.comparisionData.chartData.forEach((element, ind) => {
                if (plotComaprisiondata[ind]) {
                    plotComaprisiondata[ind].originalX = plotComaprisiondata[ind].x;
                    plotComaprisiondata[ind].x = element.x;
                }
            });
        } else {
            if (this.props.comparisionData) {
                plotComaprisiondata = JSON.parse(JSON.stringify(this.props.comparisionData.chartData));
                this.props.data &&
                    this.props.data.chartData.forEach((element, ind) => {
                        if (plotComaprisiondata[ind]) {
                            plotComaprisiondata[ind].originalX = plotComaprisiondata[ind].x;
                            plotComaprisiondata[ind].x = element.x;
                        }
                    });
            }
        }

        let serObj = this.props.comparisionData
            ? [
                  {
                      name: `${moment(this.props.data.date.start_date).format("DD MMM YYYY")} - ${moment(this.props.data.date.end_date).format("DD MMM YYYY")}`,

                      data: this.props.comparisionData.chartData.length >= this.props.data.chartData.length ? plotComaprisiondata : this.props.data.chartData,
                      color: getSentimentColor("total"),
                  },

                  {
                      name: `${moment(this.props.comparisionData.date.start_date).format("DD MMM YYYY")} - ${moment(
                          this.props.comparisionData.date.end_date,
                      ).format("DD MMM YYYY")}`,

                      data:
                          this.props.comparisionData.chartData.length < this.props.data.chartData.length
                              ? plotComaprisiondata
                              : this.props.comparisionData.chartData,
                      //  xAxis: 1,
                      color: getSentimentColor("total") + "85",
                  },
              ]
            : [
                  {
                      name: "Total",
                      data: this.props.data.chartData,
                      color: this.props.insights__recommendation ? "#7cb5ec" : getSentimentColor("total"),
                  },
              ];

        let chartConfig = {
            chart: {
                className: "skiptranslate",
                type: "spline",
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            title: {
                text: "",
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M %p",
                    second: "%l:%M %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
                labels: {
                    style: {
                        textTransform: "normal",
                        color: this.props.insights__recommendation ? "white" : "#333333",
                    },
                },
            },
            yAxis: this.props.comparisionData
                ? {
                      gridLineWidth: this.props.showGridLines ? 2 : 0,
                      gridLineDashStyle: "ShortDash",
                      gridLineColor: "#ccd6eb",
                      lineColor: "#ccd6eb",
                      lineWidth: 1,
                      title: " ",
                  }
                : plotYdata,

            credits: {
                enabled: false,
            },
            plotOptions: {
                spline: {
                    borderWidth: 0,
                    fillOpacity: 0.5,
                    point: {
                        events: {
                            contextmenu: function (e) {
                                console.log(this);
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, Object.assign({}, this));
                            },
                        },
                    },
                },
                series: {
                    marker: {
                        symbol: "circle",
                        radius: 4,
                    },
                    // {
                    //     symbol: "triangle-down",
                    //     radius: 4,
                    // },
                    // ],
                },
            },
            tooltip: {
                followPointer: true,
                followTouchMove: true,
                shared: plotComaprisiondata ? true : false,
                crosshairs: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                useHTML: true,

                formatter: function () {
                    if (plotComaprisiondata) {
                        let str = "";
                        let ComapareVal1;
                        let ComapareVal2;
                        let dateCompare;
                        let showPercent = true;
                        for (let i = 0; i < this.points.length; i++) {
                            let temp = "";

                            ComapareVal1 = this.points[0].y;
                            ComapareVal2 = this.points[1]?.y;
                            dateCompare = this.points[1]?.point.options.originalX > this.points[1]?.point.options.x;
                            let firstColorPoint = this.points[1]?.color.endsWith("85");
                            let secondColorPoint = this.points[0]?.color.endsWith("85");

                            if ((firstColorPoint && secondColorPoint) || (!secondColorPoint && !firstColorPoint)) {
                                showPercent = false;
                            }
                            temp = `<b>${moment(
                                this.points[i].point.options.originalX ? this.points[i].point.options.originalX : this.points[i].point.options.x,
                            )
                                .tz(tz)
                                .format(
                                    "LLLL",
                                )}</b><br/><div style="margin-bottom:10px;"><span style="margin-right:10px;display:inline-block;width:8px;height:8px;background-color:${
                                this.points[i].color
                            };border-radius:10px" ></span>
                          
                            <b>${numberWithCommas(this.points[i].y)}

                            <br/>                          
                            </b> </div>`;
                            <br />;

                            str += temp;
                        }

                        if (this.points.length == 2 && showPercent) {
                            str += `${
                                ComapareVal1 < ComapareVal2
                                    ? `<div> <div style="display:flex;align-item:center"><b>${
                                          ComapareVal1 !== 0 ? (((ComapareVal2 / ComapareVal1).toFixed(2) - 1) * 100).toFixed(2) + "%" : "NA"
                                      }</b>
                                   
                                <img src=${dateCompare ? UpIcon : DownIcon} width="16px" height="16px" style="margin-left:5px;transform:${
                                          dateCompare && "rotate(180deg)"
                                      }" />
                                </div>
                             
                            
                            
                                
                                </div>`
                                    : ComapareVal1 > ComapareVal2
                                    ? `<div> <div style="display:flex;align-item:center"><b>${
                                          ComapareVal2 !== 0 ? (((ComapareVal1 / ComapareVal2).toFixed(2) - 1) * 100).toFixed(2) + "%" : "NA"
                                      }</b>
                                   
                                    <img src=${dateCompare ? DownIcon : UpIcon} width="16px" height="16px" style="margin-left:5px;transform:${
                                          !dateCompare && "rotate(180deg)"
                                      }" />
                                    </div>
                                 
                                
                                
                                    
                                    </div>`
                                    : ""
                            }`;
                        }

                        return str;
                    } else {
                        return `${moment(this.x).tz(tz).format("LLLL")}<br/>${this.point?.series?.name}: <b>${numberWithCommas(this.y)}</b>`;
                    }
                },
            },

            series: serObj,

            legend: {
                // enabled: this.props.showLegend,
                itemStyle: {
                    fontWeight: 500,
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "normal",
                    color: this.props.insights__recommendation ? "white" : "#333333",
                },

                itemHoverStyle: {
                    color: this.props.insights__recommendation ? "#84acd1" : "#000000",
                },
            },
            time: {
                timezoneOffset: tzo,
            },
        };

        return chartConfig;
    };

    render() {
        return (
            <HighchartsReact
                highcharts={Highcharts}
                options={this.getOptions()}
                ref={this.chartComponent}
                containerProps={{ style: { width: "100%", height: "100%" } }}
            />
        );
    }
}

export default ConversationOverTimeWithAverageBandChart;
